import { Followup } from '../types/FollowUp';
import { toCamelCase, toSnakeCase } from '../utils/caseConverter';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchFollowups = () => {
  return fetch(`${API_BASE_URL}/api/followups`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      }).then(res => res.json()).then(data => toCamelCase(data));
};

export async function createFollowUp(data: Followup): Promise<{ id: number }> {
  const res = await fetch(`${API_BASE_URL}/api/followups`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify(toSnakeCase(data)),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to create followup: ${errorText}`);
  }

  return res.json();
}

export const fetchFollowupsForAQuery = (queryID: number) => {
  return fetch(`${API_BASE_URL}/api/followups/query/${queryID}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
         }).then(res => res.json()).then(data => toCamelCase(data));
};

export const fetchFollowupsForToday = () => {
  return fetch(`${API_BASE_URL}/api/followups/today`, {
             headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          }).then(res => res.json()).then(data => toCamelCase(data));
};

export const closeQuery = async (followupId: number, note: string) => {
  const response = await fetch(`${API_BASE_URL}/api/followups/${followupId}/close`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify({ note }),
  });

  if (!response.ok) {
    throw new Error('Failed to close query');
  }

  return await response.json();
};

export const saveFollowupInteraction = async (followupId: number, notes: string, outcome: string) => {
  const response = await fetch(`${API_BASE_URL}/api/followups/${followupId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify({ notes, outcome }),
  });

  if (!response.ok) {
    throw new Error('Failed to save followup interaction');
  }

  return await response.json();
};
